import './ProductFilter.less';
import React, {useState, useEffect} from 'react';
import AttributeGroup from "./attribute-group/AttributeGroup";
import PriceGroup from "./price-group/PriceGroup";
import Icon from "../../../components/icon/Icon";
import __ from "../../../i18n";
import isBeforePriceRangeGroup from "./utils/isBeforePriceRangeGroup";
import SummaryBlock from "./summary-block/SummaryBlock";
import LayoutPortal from "../../../layout/components/layout-portal/LayoutPortal";

export default function ProductFilter(
    {
        attributeGroups = [],
        attributes = [],
        defaultGroupedAttributeIds = {},
        defaultPriceRange = [null, null],
        onGroupedAttributeIdsChange = (groupedAttributeIds) => {},
        onPriceRangeChange = (priceRange) => {},
    }
) {

    const [groupedAttributeIds, setGroupedAttributeIds] = useState(defaultGroupedAttributeIds);

    const patchGroupAttributeIds = (groupId, attributeIds) => {
        const newObj = Object.assign({}, groupedAttributeIds, {[groupId]: attributeIds});

        if (attributeIds.length === 0) {
            delete newObj[groupId];
        }

        setGroupedAttributeIds(newObj);
    };

    const [priceRange, setPriceRange] = useState(defaultPriceRange);

    const [forcedPriceRange, setForcedPriceRange] = useState(undefined);

    useEffect(() => {
        if (forcedPriceRange !== undefined) {
            setPriceRange(forcedPriceRange);
            setForcedPriceRange(undefined);
        }
    }, [forcedPriceRange]);

    useEffect(() => {
        if (groupedAttributeIds !== defaultGroupedAttributeIds) {
            onGroupedAttributeIdsChange(groupedAttributeIds);
        }
    }, [groupedAttributeIds]);

    useEffect(() => {
        if (priceRange !== defaultPriceRange) {
            onPriceRangeChange(priceRange);
        }
    }, [priceRange]);

    const renderAttributeGroups = (isBefore) => {
        return attributeGroups
            .filter(t => isBefore ? isBeforePriceRangeGroup(t) : !isBeforePriceRangeGroup(t))
            .map(group => {
                return <AttributeGroup
                    key={group.id}
                    attributeGroup={group}
                    attributes={attributes}
                    selectedAttributeIds={groupedAttributeIds[group.id]}
                    setSelectedAttributeIds={attributeIds => patchGroupAttributeIds(group.id, attributeIds)}
                    defaultCollapsed={!isBefore}
                />;
            });
    };

    const [mobileOpened, setMobileOpened] = useState(false);

    const [filterCount, setFilterCount] = useState(0);

    const Wrapper = mobileOpened ? LayoutPortal : React.Fragment;

    return <>
        <div className="product-filter-mobile-toggle">
            <button type="button" onClick={ev => setMobileOpened(true)}>
                <span className="icon-holder">
                    <Icon name="filter"/>
                    {
                        filterCount > 0 &&
                        <span className="counter">
                            {__(':number', {number: filterCount})}
                        </span>
                    }
                </span>
                <span className="label">{__('Filter')}</span>
            </button>
        </div>
        <Wrapper>
        <div className={`product-filter ${mobileOpened ? 'mobile-opened' : ''}`}>
            <div className="heading">
                <Icon name="filter"/>
                <div className="text">{__('Product filter')}</div>
            </div>

            <div className="body">
                <SummaryBlock
                    attributeGroups={attributeGroups}
                    attributes={attributes}
                    groupedAttributeIds={groupedAttributeIds}
                    patchGroupAttributeIds={patchGroupAttributeIds}
                    clearGroupedAttributeIds={() => setGroupedAttributeIds({})}
                    priceRange={priceRange}
                    applyPriceRange={setForcedPriceRange}
                    onNumberOfItemsChange={setFilterCount}
                />

                {renderAttributeGroups(true)}

                <PriceGroup
                    defaultCollapsed={false}
                    defaultMinPrice={priceRange[0]}
                    defaultMaxPrice={priceRange[1]}
                    forcedMinPrice={forcedPriceRange && forcedPriceRange[0]}
                    forcedMaxPrice={forcedPriceRange && forcedPriceRange[1]}
                    apply={(min, max) => setPriceRange([min, max])}
                />

                {renderAttributeGroups(false)}
            </div>

            <div className="mobile-bottom-bar">
                <button type="button" onClick={ev => setMobileOpened(false)}>
                    {__('Ok, see products')}
                </button>
            </div>
        </div>
        </Wrapper>
    </>;
}
